import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useNavigate } from "react-router-dom";
import { useCreateDivision, useRetrieveDivisionsBySeasonId, } from "../api/DivisionApiProvider";
import { useRetrieveUserLeaguePermissions } from "../api/PermissionApiProvider";
import { ErrorView } from "../nav/Error";
import { Loading } from "../nav/Loading";
import { NotFound } from "../nav/NotFound";
import ErrorSnackbar from "../utils/ErrorSnackbar";
import { useNumericParams } from "../utils/useNumericParams";
import { DivisionForm } from "./DivisionForm";
export const CreateDivision = () => {
    const { leagueId, seasonId } = useNumericParams();
    const navigate = useNavigate();
    const { data: permissions, isLoading: permissionsLoading, error: permissionsError, } = useRetrieveUserLeaguePermissions({ leagueId });
    const { canModify = false } = permissions || {};
    const { data: divisions = [], isLoading: divisionsLoading } = useRetrieveDivisionsBySeasonId({
        seasonId,
        enabled: !!seasonId && canModify,
    });
    const mutation = useCreateDivision({
        onMutate: () => { },
        onSuccess: (data) => {
            const division = data.data;
            navigate(`/leagues/${leagueId}/seasons/${division.season}`);
        },
        onError: () => { },
    });
    if (!seasonId || !leagueId) {
        return _jsx(ErrorView, { error: new Error("Missing season or league id") });
    }
    if (permissionsLoading || mutation.isLoading || divisionsLoading) {
        return _jsx(Loading, {});
    }
    if (permissionsError) {
        return _jsx(ErrorView, { error: permissionsError });
    }
    if (!canModify) {
        return _jsx(NotFound, {});
    }
    return (_jsxs(_Fragment, { children: [_jsx(ErrorSnackbar, { open: mutation.isError, message: "Failed to create division. Please try again.", onClose: () => { } }), _jsx(DivisionForm, { onSubmit: (data) => mutation.mutate(data), seasonId: seasonId, existingDivisions: divisions })] }));
};
